module.exports = __webpack_public_path__ + "static/media/Fabrication Tracker.c3893f7b.png";